export enum FeatureEntitlements {
  LifecycleCRM = 'whitelabel_lifecycle_crm',
  TargetingApiSegmentTooling = 'targeting_api_segment',
}
